import { AdminTag } from "@/components";
import { useAmityAuth, useTranslate } from "@/providers/context";
import { cn } from "@/utils";

import { CommunityUserAvatar } from "..";
import { isCommunityAdmin } from "../../util";

export const CommunityPostHeader = ({
  onClick,
  className,
}: {
  onClick?: () => void;
  className?: string;
}) => {
  const { translate } = useTranslate();
  const { authState } = useAmityAuth();

  return (
    <div className={cn("mb-8 ml-3 flex items-center gap-4", className)}>
      <CommunityUserAvatar />
      {onClick ? (
        <div
          className="p2-medium flex h-10 w-full cursor-text items-center rounded-lg bg-surface-secondary px-3 text-item-secondary transition-colors duration-100 hover:bg-surface-tertiary"
          onClick={onClick}
        >
          {translate("What's on your mind?")}
        </div>
      ) : (
        <div className="flex items-center gap-2 overflow-hidden pr-7">
          <div className="p1-semibold ellipsis">
            {authState?.authenticatedUser?.displayName}
          </div>
          {isCommunityAdmin(authState?.authenticatedUser) && <AdminTag />}
        </div>
      )}
    </div>
  );
};
